import React, { useState } from 'react';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, Configure } from 'react-instantsearch-dom';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  maxBreakpointQuery,
  standardColours,
  fontSize,
  zIndexLayers,
  standardTransition,
  visuallyHidden,
} from '../styles';
import SearchBox from './SearchBox';
import SearchResult from './SearchResult';
import { Svg } from './ui';
import searchIcon from '../images/search-icon.inline.svg';

const StyledSearch = styled.div`
  ${maxBreakpointQuery.mlarge`
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    padding: 80px 30px;
    background-color: ${standardColours.white};
    z-index: ${zIndexLayers.fourth};
    transform: translateY(
      ${({ isOpen }) => (isOpen ? '0' : '-100%')}
    );
    transition: ${standardTransition('transform')};
  `}

  ${minBreakpointQuery.mlarge`
    position: relative;
  `}
`;

const StyledOpen = styled.button`
  ${maxBreakpointQuery.mlarge`
    line-height: 1;
    background: none;
    border: none;
  `}

  ${minBreakpointQuery.mlarge`
    ${visuallyHidden()};
  `}
`;

const StyledIcon = styled(Svg)`
  ${maxBreakpointQuery.mlarge`
    height: 18px;
    width: 18px;
  `}
`;

const StyledClose = styled.button`
  ${maxBreakpointQuery.mlarge`
    position: absolute;
    top: 15px;
    right: 30px;
    padding: 2px;
    ${fontSize(24)};
    background: none;
    border: none;
  `}

  ${minBreakpointQuery.mlarge`
    ${visuallyHidden()};
  `}
`;

const Search = ({ isOpen, setOpen, ...props }) => {
  const [query, setQuery] = useState();
  const [hasFocus, setFocus] = useState(false);

  const algoliaClient = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID,
    process.env.GATSBY_ALGOLIA_SEARCH_KEY
  );

  const searchClient = {
    search(requests) {
      if (requests[0].params.query === '') {
        return [];
      }

      return algoliaClient.search(requests);
    },
  };

  const indices = [{ name: `Products`, title: `Products` }];

  return (
    <>
      <StyledOpen
        aria-label="Open Search"
        onClick={() => setOpen(true)}
        {...props}
      >
        <StyledIcon image={searchIcon} />
      </StyledOpen>
      <StyledSearch isOpen={isOpen} {...props}>
        <InstantSearch
          searchClient={searchClient}
          indexName={indices[0].name}
          onSearchStateChange={({ query }) => setQuery(query)}
        >
          <SearchBox onFocus={() => setFocus(true)} hasFocus={hasFocus} />
          <SearchResult indices={indices} show={query && query.length > 0} />
          <Configure hitsPerPage={6} />
        </InstantSearch>
        <StyledClose aria-label="Close Search" onClick={() => setOpen(false)}>
          ✕
        </StyledClose>
      </StyledSearch>
    </>
  );
};

export default Search;
